import {
    Button,
    Col,
    Container,
    Form,
    Modal,
    Row,
    Card,
} from "react-bootstrap";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { ThreeDotSpinner } from "../loader";
import { baseUrl, dateFormate } from "../../config/config";
import swal from "sweetalert";
import { apiService } from "../../service/api.service";
import ImageUploadBox from "./ImageUploadBox";
import Pagination from "react-js-pagination";

export const BannerManagement = () => {
    const [loader, setLoader] = useState(false);
    const [bannerList, setBannerList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [formValues, setFormValues] = useState({
        title: "",
        webImage: null,
        mobileImage: null,
        redirectUrl: "",
        forOfferPage:false
    });
    const [webPreview, setWebPreview] = useState(null);
    const [mobilePreview, setMobilePreview] = useState(null);
    const [error, setError] = useState({});
    const [downloadingId, setDownloadingId] = useState(null)

    const [page, setPage] = useState(1);
    const [items, setItems] = useState(0);

    const showImages = (url) => {
        return `${baseUrl}${url}`
    }

    const handlePageChange = (pageNumber) => {
        if (page != pageNumber) {
            setPage(pageNumber);
            fetchBanners(pageNumber);
        }
    };

    useEffect(() => {
        fetchBanners();
    }, []);

    const fetchBanners = async (pageNumber = 1) => {
        setLoader(true);
        try {
            const response = await apiService.getBanners(pageNumber);
            if (response?.status === 200) {
                setBannerList(response.data.data);
                setItems(response.data.totalRecords);
            }
        } catch (err) {
            swal({
                icon: "error",
                text: err?.response?.data?.message || err?.message,
                button: "OK",
            });
        } finally {
            setLoader(false);
        }
    };

    const handleOpenModal = (banner = null) => {
        if (banner) {
            setSelectedBanner(banner);
            setFormValues({
                title: banner.title,
                webImage: null,
                mobileImage: null,
                redirectUrl: banner.redirectUrl,
                forOfferPage:banner.forOfferPage?banner.forOfferPage:false
            });
            setWebPreview(banner.imageWebUrl ? showImages(banner.imageWebUrl) : null);
            setMobilePreview(banner.imageMobileUrl ? showImages(banner.imageMobileUrl) : null);
        } else {
            setSelectedBanner(null);
            setFormValues({ title: "", webImage: null, mobileImage: null, redirectUrl: "",forOfferPage:false });
            setWebPreview(null);
            setMobilePreview(null);
        }
        setError({});
        setShowModal(true);
    };

    const validateForm = () => {
        let errors = { ...error };
        if (!formValues.title.trim()) errors.title = "Title is required.";

        if (!formValues.webImage && !webPreview) {
            errors.webImage = "Web image is required.";
        }
        if (!formValues.mobileImage && !mobilePreview) {
            errors.mobileImage = "Mobile image is required.";
        }

        if (!formValues.redirectUrl.trim()) {
            errors.redirectUrl = "Redirect URL is required.";
        } else {
            const urlPattern = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
            if (!urlPattern.test(formValues.redirectUrl)) {
                errors.redirectUrl = "Invalid URL.";
            }
        }

        console.log(errors)
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append("title", formValues.title);
        if (formValues.webImage) formData.append("banner_web", formValues.webImage);
        if (formValues.mobileImage) formData.append("banner_mob", formValues.mobileImage);
        formData.append("redirectUrl", formValues.redirectUrl);
        formData.append("forOfferPage", formValues.forOfferPage);
        

        try {
            setLoader(true);
            let response;
            if (selectedBanner) {
                response = await apiService.updateBanner(selectedBanner._id, formData);
            } else {
                // formData.append("enabled", true);
                response = await apiService.createBanner(formData);
            }
            console.log(response)
            if (response?.status === 200 || response?.status === 201) {
                swal({ text: response?.data?.data?.message || "Banner saved successfully!", icon: "success" });
                setShowModal(false);
                fetchBanners(page);
            }
        } catch (err) {
           if(err?.response?.status && err?.response.status==413){
            swal({
                icon: "error",
                text: "Image size should not exceed 2 MB. Please upload a smaller file.",
                button: "OK",
            });

           }else{
            swal({
                icon: "error",
                text: err?.response?.data?.message || err?.message,
                button: "OK",
            });
           }
           
        } finally {
            setLoader(false);
        }
    };

    const handleToggleStatus = async (banner) => {
        try {
            setLoader(true);
            const confirm = await swal({
                icon: "info",
                text: `Are you sure you want to ${banner.enabled ? "disable" : "enable"} this banner`,
                buttons: ["No", `Yes, ${banner.enabled ? "disable" : "enable"} it`]
            })

            if (confirm) {
                const response = await apiService.updateBannerStatus(banner._id);
                if (response?.status === 200) {
                    fetchBanners();
                }
            }
        } catch (err) {
            swal({
                icon: "error",
                text: err?.response?.data?.message || err?.message,
                button: "OK",
            });
        } finally {
            setLoader(false);
        }
    };

    async function downloadCsv(id) {
        try {
          setDownloadingId(id);
          const resp = await apiService.exportBannerReportCsv(id); // <-- uses apiService
          const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
          const fileName = `${id}_banner_report.csv`;
    
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          link.remove();
        } catch (e) {
          swal({ icon: "error", text: e?.message || "Download failed", button: "OK" });
        } finally {
          setDownloadingId(null);
        }
      }

    return (
        <div className="dashboard-main-area">
            {loader && <ThreeDotSpinner />}
            <Container fluid>
                <div className="dashboard-area-heading management-heading">
                    <Row className="row justify-content-between align-items-center mb-3 pe-4">
                        <Col md={6}>
                            <div className="heading-top-area">
                                <h2 className="ms-5">Banner Management</h2>
                            </div>
                        </Col>
                        <Col md={6} className="text-end">
                            <Button onClick={() => handleOpenModal()}><i className="fa fa-plus"></i> Add Banner</Button>
                        </Col>
                    </Row>

                    <Row className="pb-4 justify-content-center ms-4">
                        {bannerList?.length > 0 ? (
                            bannerList.map((banner) => (
                                <Col md={4} sm={6} xs={12} key={banner._id} className="mb-4">
                                    <Card className="h-100 bannr-card">
                                        <div className="card-header">
                                            <h5 className="fw-bold">{banner.title}</h5>
                                           {banner.forOfferPage? <p>Offer Page Banner</p>:null}
                                        </div>
                                        
                                        <div className="d-flex justify-content-between align-items-left mt-3 border-top pt-3">
                                                {/* <Form.Check
                                                    type="switch"
                                                    checked={banner.forOfferPage}
                                                 
                                                    label={"Offer Page Banner"}
                                                /> */}
                                             
                                            </div>
                                        <Card.Body>
                                            <div className="preview-grid">
                                                <div className="preview-item">
                                                    <div className="preview-label">
                                                        <svg className="device-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                                                        </svg>
                                                        Web Image
                                                    </div>
                                                    {banner.imageWebUrl ? (
                                                        <img
                                                            src={showImages(banner.imageWebUrl)}
                                                            alt="web"
                                                            style={{
                                                                width: "100%",
                                                                maxWidth: "320px",
                                                                height: "auto",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </div>
                                                <div className="preview-item">
                                                    <div className="preview-label">
                                                        <svg className="device-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a1 1 0 001-1v-1H7v1a1 1 0 001 1zM10 2h4a1 1 0 011 1v3H9V3a1 1 0 011-1zM9 7h6v10H9V7z"></path>
                                                        </svg>
                                                        Mobile Image
                                                    </div>
                                                    {banner.imageMobileUrl ? (
                                                        <img
                                                            src={showImages(banner.imageMobileUrl)}
                                                            alt="mobile"
                                                            style={{
                                                                width: "100%",
                                                                maxWidth: "260px",
                                                                height: "auto",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </div>
                                            </div>
                                            <p className="mb-1 redirect-link">
                                                <strong>Redirect:</strong>{" "}
                                                <a href={banner.redirectUrl} target="_blank" rel="noreferrer">
                                                    {banner.redirectUrl}
                                                </a>
                                            </p>
                                            <p className="mb-1">
                                                <strong>Updated:</strong>{" "}
                                                {banner.updatedAt
                                                    ? moment(banner.updatedAt).format(dateFormate)
                                                    : "N/A"}
                                            </p>
                                            <p className="mb-1">
                                                <strong>Total Clicks:</strong>{" "}
                                                {banner.clicksAllTime
                                                    ? banner.clicksAllTime
                                                    : "0"} 
                                            </p>
                                            <p className="mb-1">
                                                <strong>Clicks last 24 hours:</strong>{" "}
                                                {banner.clicksLast24h
                                                    ? banner.clicksLast24h
                                                    : "0"} 
                                            </p>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={()=>{downloadCsv(banner._id)}}
                                                disabled={downloadingId === banner._id}
                                            >
                                                {downloadingId === banner._id ? "Preparing…" : "Download CSV"}
                                            </button>
                                            <div className="d-flex justify-content-between align-items-center mt-3 border-top pt-3">
                                                <Form.Check
                                                    type="switch"
                                                    checked={banner.enabled}
                                                    onChange={() => handleToggleStatus(banner)}
                                                    label={banner.enabled ? "Enabled" : "Disabled"}
                                                />
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    className="bannr-edit"
                                                    onClick={() => handleOpenModal(banner)}
                                                >
                                                    <i className="fa fa-pencil"></i> Edit
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col md={12} className="text-center">
                                <img
                                    src={require("../../assets/images/no-data.svg").default}
                                    alt="no-data"
                                    width={120}
                                />
                                <h3 className="text-light">No banners found</h3>
                            </Col>
                        )}
                    </Row>

                    {items && items > 9 && (
                        <div className="d-flex justify-content-center mt-4">
                            <Pagination
                                activePage={page}
                                itemsCountPerPage={10}
                                totalItemsCount={items}
                                pageRangeDisplayed={5}
                                onChange={(e) => handlePageChange(e)}
                                prevPageText="Prev"
                                nextPageText="Next"
                            />
                        </div>
                    )}
                </div>
            </Container>

            {/* Add/Edit Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedBanner ? "Edit Banner" : "Add Banner"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                    <Form.Group className="mb-3">
                          
                            <Form.Check
                                type="switch"
                                id="forOfferSwitch"
                                label="Offer Page Banner"
                                checked={formValues.forOfferPage}
                                onChange={(e) =>
                                    setFormValues({ ...formValues, forOfferPage: e.target.checked })
                                }
                                />

                            {error.title && <span className="text-danger">{error.title}</span>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                style={{
                                    border: error["title"] && "1px solid red"
                                }}
                                type="text"
                                value={formValues.title}
                                onChange={(e) => {
                                    setFormValues({ ...formValues, title: e.target.value })
                                    setError((prev) => {
                                        const newErrors = { ...prev };
                                        delete newErrors.title;
                                        return newErrors;
                                    });
                                }}
                                placeholder="Enter banner title"
                            />
                            {error.title && <span className="text-danger">{error.title}</span>}
                        </Form.Group>

                        <ImageUploadBox
                            label="Web Image (320x140)"
                            preview={webPreview}
                            setPreview={setWebPreview}
                            width="320px"
                            height="140px"
                            onFileSelect={(file) =>
                                setFormValues({ ...formValues, webImage: file })
                            }
                            error={error}
                            setError={setError}
                            name="webImage"
                            required
                        />

                        <ImageUploadBox
                            label="Mobile Image (260x140)"
                            preview={mobilePreview}
                            setPreview={setMobilePreview}
                            width="260px"
                            height="140px"
                            onFileSelect={(file) =>
                                setFormValues({ ...formValues, mobileImage: file })
                            }
                            error={error}
                            setError={setError}
                            name="mobileImage"
                            required
                        />

                        <Form.Group className="mb-3">
                            <Form.Label>Redirect URL</Form.Label>
                            <Form.Control
                                type="text"
                                style={{
                                    border: error["redirectUrl"] && "1px solid red"
                                }}
                                value={formValues.redirectUrl}
                                onChange={(e) => {
                                    setFormValues({ ...formValues, redirectUrl: e.target.value })
                                    setError((prev) => {
                                        const newErrors = { ...prev };
                                        delete newErrors.redirectUrl;
                                        return newErrors;
                                    });
                                }}
                                placeholder="https://example.com"
                            />
                            {error.redirectUrl && (
                                <span className="text-danger">{error.redirectUrl}</span>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
